<template>
<!-- Start Services List
    ============================================= -->
    <div class="services-list-area default-padding-bottom pt-5">
      <div class="container">
        <div class="services-list-items">
          <div class="row align-center">
            <div class="col-lg-5 thumb">
              <img src="assets/img/illustration/14.png" alt="Thumb" />
            </div>
            <div class="col-lg-7">
              <div class="row">
                <div class="col-lg-6 col-md-6 single-item">
                  <a href="#"
                    ><i class="fas fa-trash-alt"></i>
                    <span>Mantención de base de datos </span></a
                  >
                </div>
                <div class="col-lg-6 col-md-6 single-item">
                  <a href="#"
                    ><i class="fas fa-award"></i
                    ><span>
                      Análisis de calidad y salud de sus aplicaciones</span
                    ></a
                  >
                </div>
                <div class="col-lg-6 col-md-6 single-item">
                  <a href="#"
                    ><i class="fas fa-database"></i>
                    <span>Respaldo de sus bases de datos</span></a
                  >
                </div>
                <div class="col-lg-6 col-md-6 single-item">
                  <a href="#"
                    ><i class="fas fa-hdd"></i>
                    <span>Disponibilidad Inmediata</span></a
                  >
                </div>
                <div class="col-lg-6 col-md-6 single-item">
                  <a href="#"
                    ><i class="fab fa-angular"></i>
                    <span>Administración de Aplicaciones</span></a
                  >
                </div>
                <div class="col-lg-6 col-md-6 single-item">
                  <a href="#"
                    ><i class="fas fa-rocket"></i>
                    <span>Integración de software con API</span></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Services List -->
</template>


<script>
    export default {
        name: "Banner4",
        components: {},
        beforeMount() {},
    };
</script>